var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content)?_c('div',{staticClass:"pigment-code"},[_c('div',{staticClass:"pigment-code__top"},[_c('PigmentCodeBanner'),_c('PigmentCodeProgram'),_c('PigmentCodeWhatYouGet'),_c('PigmentCodeFormat'),_c('PigmentCodeSlider')],1),_c('PigmentCodeImage'),_c('PigmentCodeEvents'),_c('PigmentCodeList')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }